'use strict';

var Type = require('../type');

function resolveYamlMerge(data) {
  return data === '<<' || data === null;
}

module.exports = new Type('tag:yaml.org,2002:merge', {
  kind: 'scalar',
  resolve: resolveYamlMerge
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/json-schema-ref-parser/~/js-yaml/lib/js-yaml/type/merge.js
 ** module id = 148
 ** module chunks = 0
 **/